var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBracket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 73,
    viewBox: "0 0 42 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0H17.7C20.2196 0 22.6359 1.28184 24.4175 3.56353C26.1991 5.84523 27.2 8.93987 27.2 12.1667V34.0667H31V38.9333H27.2V60.8333C27.2 64.0601 26.1991 67.1548 24.4175 69.4365C22.6359 71.7182 20.2196 73 17.7 73H12V68.1333H17.7C19.2117 68.1333 20.6616 67.3642 21.7305 65.9952C22.7995 64.6262 23.4 62.7694 23.4 60.8333V12.1667C23.4 10.2306 22.7995 8.3738 21.7305 7.00479C20.6616 5.63577 19.2117 4.86667 17.7 4.86667H12V0Z",
    fill: "#8D8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBracket);
export default __webpack_public_path__ + "static/media/Bracket.bda3b73867034067bdb4767c4c7a6a66.svg";
export { ForwardRef as ReactComponent };